var exports = {
  "zr": "ProfileStatLinks.module__root___MzV3Z2",
  "nf": "ProfileStatLinks.module__link___MzV3Z2",
  "ai": "ProfileStatLinks.module__number___MzV3Z2",
  "Kk": "ProfileStatLinks.module__icon___MzV3Z2",
};

module.exports = exports;
